<template>
  <img :src="volumeIcon" alt="Volume Icon" width="70px" height="70px">
</template>

<script>
import volumeGif from 'src/modules/industry/industrial-map/movimentacoes-industriais/mapa-industrial-dinamico/imgs/volume.gif'
export default {
  name: 'VolumeIcon',
  data () {
    return {
      volumeIcon: volumeGif
    }
  }
}
</script>
